module.exports = __webpack_public_path__ + "d466a021df3570c0a690a9de9dac9060.svg";